import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    allRightsReserved: '© 2025 All rights reserved',
    docs: 'Docs',
    x: 'X',
    discord: 'Discord',
    comingSoon: 'Coming soon',
  },
};
